import React from 'react';
import { Icon } from './Icon.js';
export const IconMobileChatBubble = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9 22L5 22L5 2L19 2L19 10", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M11 6L13 6", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M21 14H13V22H14.5L16 20H21V14Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconMobileChatBubble.js.map